import React from "react";

const HelpPage = () => {
  return <div>Help Page</div>;
};

export default HelpPage;
